<div class="social-disadvantage-calculator" *transloco="let t">
  <div class="scale-legend">
    {{ t('child/socialDisadvantageScaleLegend') }}
  </div>

  @for (factor of factors; track factor.key) {
  <div class="factor-row">
    <div class="factor-label">
      <strong>{{ factor.letter }}.</strong> {{ t(factor.titleKey) }}
      <i [class]="iconService.infoCircle + ' tooltip-icon'" placement="top" [ngbTooltip]="t(factor.tooltipKey)"></i>
    </div>
    <div class="btn-group factor-score" role="group" [attr.aria-label]="t(factor.titleKey)">
      @for (score of scores; track score) {
      <input
        type="radio"
        class="btn-check"
        [id]="factor.key + '-' + score"
        [name]="factor.key"
        [value]="score"
        [checked]="hasValidCode() && factorScores()[factor.key] === score"
        (change)="select(factor.key, score)"
      />
      <label class="btn btn-outline-primary" [for]="factor.key + '-' + score">{{ score }}</label>
      }
    </div>
  </div>
  }

  <div class="result-summary">
    @if (hasValidCode()) {
    <span
      >{{ t('child/socialDisadvantageTotalScore') }}: <strong>{{ category().total }}</strong></span
    >
    <span>{{ t(category().labelKey) }}</span>
    } @else {
    <span>{{ t('child/socialDisadvantageIncompleteCode') }}</span>
    }
  </div>
</div>
